import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { t } from '../../lang';

import './Input.scss';

const Input = ({
	className = '',
	disabled = false,
	success = false,
	error = false,
	maxLength = null,
	onChange = () => {},
	placeholder = null,
	prefix = null,
	postfix = null,
	type = 'text',
	value = '',
	bottomSeparator = false,
	subtext = '',
	autoFocus = false,
	autoFocusOnClick = true,
	externalRef,
	...props
}) => {
	const inputRef = useRef();

	const delayedFocus = () => {
		setTimeout(() => {
			inputRef.current?.focus();
		}, 350);
	};

	useEffect(() => {
		if (autoFocus) delayedFocus();
	}, []);

	const ref = externalRef ?? inputRef;

	return (
		<div
			className={classNames('Input', className, {
				InputSuccess: success,
				InputError: error,
				InputDisabled: disabled,
			})}
		>
			<div className='Input__field'>
				{prefix && <div className='Input__prefix'>{prefix}</div>}
				<div
					className={classNames('Input__content', {
						'Input__bottom-separator': bottomSeparator,
					})}
				>
					<input
						ref={ref}
						type={type}
						placeholder={placeholder}
						value={value}
						onChange={onChange}
						maxLength={maxLength || 'auto'}
						disabled={disabled}
						{...props}
					/>
					{postfix && (
						<div
							className='Input__postfix'
							onClick={() => autoFocusOnClick && ref.current.focus()}
						>
							{postfix}
						</div>
					)}
				</div>
			</div>
			{subtext && (
				<div className='Input__subtext'>
					{typeof subtext === 'string' ? t(subtext) : subtext}
				</div>
			)}
		</div>
	);
};

Input.propTypes = {
	className: PropTypes.string,
	disabled: PropTypes.bool,
	success: PropTypes.bool,
	error: PropTypes.bool,
	maxLength: PropTypes.number,
	onChange: PropTypes.func,
	placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	postfix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	type: PropTypes.string,
	value: PropTypes.string,
	bottomSeparator: PropTypes.bool,
	subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default Input;
